import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPercent = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 20,
	viewBox: "0 0 18 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.625 8.75C7.04297 8.75 9 6.79297 9 4.375C9 1.95703 7.04297 0 4.625 0C2.20703 0 0.25 1.95703 0.25 4.375C0.25 6.79297 2.20703 8.75 4.625 8.75ZM4.625 2.5C5.66016 2.5 6.5 3.33984 6.5 4.375C6.5 5.41016 5.66016 6.25 4.625 6.25C3.58984 6.25 2.75 5.41016 2.75 4.375C2.75 3.33984 3.58984 2.5 4.625 2.5ZM13.375 11.25C10.957 11.25 9 13.207 9 15.625C9 18.043 10.957 20 13.375 20C15.793 20 17.75 18.043 17.75 15.625C17.75 13.207 15.793 11.25 13.375 11.25ZM13.375 17.5C12.3398 17.5 11.5 16.6602 11.5 15.625C11.5 14.5898 12.3398 13.75 13.375 13.75C14.4102 13.75 15.25 14.5898 15.25 15.625C15.25 16.6602 14.4102 17.5 13.375 17.5ZM15.5742 0.0078125L16.8086 0.00390625C17.5664 0 18.0156 0.855469 17.5781 1.48047L3.27344 19.5938C3.18719 19.7168 3.07258 19.8172 2.93932 19.8865C2.80605 19.9559 2.65804 19.9921 2.50781 19.9922L1.20312 19.9961C0.441406 19.9961 -0.00390625 19.1406 0.433594 18.5195L14.8086 0.40625C14.9844 0.15625 15.2695 0.0078125 15.5742 0.0078125Z",
		fill: "currentColor"
	})
});
export default SvgPercent;
